import React from 'react';
import { GitFork } from 'lucide-react';

export default function Projects() {
    return (
        <section id="projects" className="mb-12 px-4 sm:px-6 lg:px-8">
            <h2 className="text-2xl font-bold mb-6 pb-2 border-b-2 border-blue-500">PROJECTS</h2>

            {/* Project 1 */}
            <div className="bg-white p-6 rounded-lg shadow-md mb-6">
                <div className="flex flex-col sm:flex-row justify-between items-start mb-2">
                    <h3 className="font-bold text-lg sm:text-xl text-blue-800 mb-2 sm:mb-0">Hand Cricket Game – Client-Server Model Using C++</h3>
                    <span className="text-gray-600">{`Aug'23 - Nov'23`}</span>
                </div>
                <p className="italic mb-2">Advanced Computer Networks, IIT Hyderabad</p>
                <p className="mb-4 flex items-center gap-2">
                    <GitFork size={16} className="text-blue-800" />
                    Github Repository: <a href="https://github.com/AgarwalKritik/Public/tree/main/M.Tech%20@%20IIT-Hyderabad/CS5060-Advanced%20Computer%20Networks/Socket%20Programming/Hand%20Cricket" className="text-blue-600 hover:underline">Hand Cricket - Socket Programming</a>
                </p>
                <ul className="list-disc pl-6 space-y-2">
                    <li>Designed and implemented a network-based Hand Cricket game using C++ and socket programming.</li>
                    <li>Developed a client-server architecture where the client selects a number between 1-6 and the server generates a random number in the same range. If the numbers match, the client loses a wicket; otherwise, the client gains runs equal to the chosen number.</li>
                    <li>Engineered the server to manage real-time score tracking, providing the client with updates after every interaction.</li>
                    <li>Utilized TCP/IP communication protocols to ensure reliable data transmission between client and server, optimizing for performance and handling multiple connections efficiently.</li>
                </ul>
            </div>

            {/* Project 2 */}
            <div className="bg-white p-6 rounded-lg shadow-md mb-6">
                <div className="flex flex-col sm:flex-row justify-between items-start mb-2">
                    <h3 className="font-bold text-lg sm:text-xl text-blue-800 mb-2 sm:mb-0">Code Crusade – Capture the Flag (CTF) Challenge</h3>
                    <span className="text-gray-600">Apr'24</span>
                </div>
                <p className="italic mb-2">Network Security, IIT Hyderabad</p>
                <p className="mb-4 flex items-center gap-2">
                    <GitFork size={16} className="text-blue-800" />
                    Github Repository: <a href="https://github.com/AgarwalKritik/Public/tree/main/M.Tech%20@%20IIT-Hyderabad/CS6903-Network%20Security/CTF%20Assignment" className="text-blue-600 hover:underline">Code Crusade - CTF</a>
                </p>
                <ul className="list-disc pl-6 space-y-2">
                    <li>Competed in a team-based CTF challenge designed to identify and exploit network vulnerabilities.</li>
                    <li>Developed a Python script to automate attacks, retrieving the first four flags through network exploitation techniques.</li>
                    <li>Exploited security flaws to gain access to the server and manually captured the final four flags.</li>
                    <li>Utilized skills in cryptography, reverse engineering, and web exploitation to solve security challenges.</li>
                </ul>
            </div>

            {/* Project 3 */}
            <div className="bg-white p-6 rounded-lg shadow-md">
                <div className="flex flex-col sm:flex-row justify-between items-start mb-2">
                    <h3 className="font-bold text-lg sm:text-xl text-blue-800 mb-2 sm:mb-0">Synthetic Data Generation Using VAE</h3>
                    <span className="text-gray-600">Jan'24 - Apr'24</span>
                </div>
                <p className="italic mb-2">Fraud Analytics Using Predictive and Social Network Techniques, IIT Hyderabad</p>
                <p className="mb-4 flex items-center gap-2">
                    <GitFork size={16} className="text-blue-800" />
                    Github Repository: <a href="https://github.com/AgarwalKritik/Public/blob/main/M.Tech%20@%20IIT-Hyderabad/CS6890-Fraud%20Analytics%20Using%20Predictive%20and%20Social%20Network%20Techniques/Synthetic_Data_Generation_Using_VAE.ipynb" className="text-blue-600 hover:underline">Synthetic Data Generation Using VAE</a>
                </p>
                <ul className="list-disc pl-6 space-y-2">
                    <li>Implemented a Variational Autoencoder (VAE) for generating 2 million synthetic credit card transactions with statistical properties matching real data.</li>
                    <li>Optimized VAE performance by scaling inputs and fine-tuning the loss function.</li>
                    <li>Evaluated model accuracy using KL divergence, ensuring high-quality data generation.</li>
                    <li>Achieved a Mean Squared Error (MSE) of 0.0845, Training Accuracy: 94.93%, Testing Accuracy: 92.49%.</li>
                </ul>
            </div>
        </section>
    );
}
